import React, { useMemo } from "react";
import JetpackCheckoutForm, {
  type JetpackCheckoutParams
} from "../17_JetpackOnboarding/components/CheckoutSubscription/JetpackCheckoutForm";
import {
  BACKGROUND,
  JETPACK_ONBOARDING_STEPS
} from "../17_JetpackOnboarding/constants";
import { useUrlQuery } from "../../utils/hooks/useUrlQuery";
import TSUtils from "../../utils/helpers/TSUtils";
import { BASE_URL } from "../../utils/constants";
import { useTrackingIdRouting } from "../../utils/routing/routingUtils";
import { useAccountToDisplaySelector } from "../../redux/actions/user";
import { useSubscriptionPlansSelector } from "../../redux/actions/app";
import { SubscriptionPlanType } from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";

export default function SubscriptionByQuote() {
  const urlQuery = useUrlQuery();
  useTrackingIdRouting("SubscriptionByQuote"); // Handle trackingID from URL

  const { accountToDisplay } = useAccountToDisplaySelector();
  const plans = useSubscriptionPlansSelector();

  const ENTERPRISE_PLAN = useMemo(() => {
    return (
      plans?.find((p) => p.type === SubscriptionPlanType.ENTERPRISE) ?? null
    );
  }, [plans]);

  const isSubscriptionPromoCode2 = useMemo(() => {
    const planStr = urlQuery.get("planId");

    if (TSUtils.isHexObjectId(planStr)) {
      return false;
    }

    return true;
  }, [urlQuery]);

  const params = useMemo<JetpackCheckoutParams>(() => {
    let planId = urlQuery.get("planId");

    if (
      !!accountToDisplay?.businessUser?.tempsSubscriptionPromoCode2 &&
      ENTERPRISE_PLAN
    ) {
      planId = ENTERPRISE_PLAN?._id;
    }

    return {
      isNew: urlQuery.get("isNew") === "true",
      placeName: urlQuery.get("placeName"),
      planId,
      duration: urlQuery.get("duration"),
      commitment: urlQuery.get("commitment"),
      spc: urlQuery.get("spc"),
      sts: urlQuery.get("sts"),
      useSamePayment: urlQuery.get("useSamePayment"),
      copyFromAccount: urlQuery.get("copyFromAccount"),
      payment_intent: urlQuery.get("payment_intent"),
      payment_intent_client_secret: urlQuery.get(
        "payment_intent_client_secret"
      ),
      redirect_status: urlQuery.get("redirect_status"),
      setup_intent: urlQuery.get("setup_intent"),
      setup_intent_client_secret: urlQuery.get("setup_intent_client_secret")
    };
  }, [urlQuery, accountToDisplay]);

  return (
    <div
      id="subscription-quote-container"
      className="w-100 h-100"
      style={{ overflowY: "scroll" }}
    >
      <img
        src={`${BASE_URL}/${BACKGROUND[JETPACK_ONBOARDING_STEPS.STEP_1_GAMES]}`}
        className="onboarding-bg"
        alt={"background_img"}
      />
      <JetpackCheckoutForm
        isSubscriptionPromoCode2={isSubscriptionPromoCode2}
        redirectToOnboardingAfterSubscription={!isSubscriptionPromoCode2}
        className="mt-0"
        params={params}
      />
    </div>
  );
}
